import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import SINGLE_USER_CONTEXT from "src/context/internal/user";
import { Subheading } from "src/components/base/heading";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/base/table";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link GeneralUserView}
 */
export type GeneralUserViewProps = {};

/**
 * The overview for a single user
 */
export default function GeneralUserView(props: GeneralUserViewProps) {
    const [t] = useTranslation("admin-user-overview");

    const ctx = React.useContext(SINGLE_USER_CONTEXT);

    return (
        <div>
            <Subheading>{t("heading.group")}</Subheading>

            {ctx.user.groups.length > 0 ? (
                <Table dense={true} className={"mt-3"}>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{t("label.name")}</TableHeader>
                            <TableHeader>{t("label.description")}</TableHeader>
                            <TableHeader>{t("label.external-id")}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ctx.user.groups.map((group) => (
                            <TableRow key={group.uuid}>
                                <TableCell>{group.name}</TableCell>
                                <TableCell>{group.description}</TableCell>
                                <TableCell>{group.external_id}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            ) : (
                <Text className={"mt-2"}>{t("label.empty-group")}</Text>
            )}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/users/$userId/_user/general")({
    component: GeneralUserView,
});
